// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"629":"252a45a9","851":"2272f02b"}[chunkId] + ".chunk.js";
};